import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const UpArrow12 = (props: SvgProps) => <Svg
  width='13'
  height='14'
  viewBox='0 0 13 14'
  fill='none'
  {...props}
>
  <Path
    d='M6.50024 3.34375V10.6562'
    stroke={props.color ?? '#A82636'}
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M9.34375 6.1875L6.5 3.34375L3.65625 6.1875'
    stroke={props.color ?? '#A82636'}
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default UpArrow12;
